import { render, staticRenderFns } from "./ShowChicksGlobalByEvo.vue?vue&type=template&id=3f56591a&scoped=true"
import script from "./ShowChicksGlobalByEvo.vue?vue&type=script&lang=js"
export * from "./ShowChicksGlobalByEvo.vue?vue&type=script&lang=js"
import style0 from "./ShowChicksGlobalByEvo.vue?vue&type=style&index=0&id=3f56591a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f56591a",
  null
  
)

export default component.exports